import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "cookie-banner__inner" }
const _hoisted_3 = { class: "cookie-banner__text" }
const _hoisted_4 = { class: "cookie-banner__heading" }
const _hoisted_5 = { class: "cookie-banner__body" }
const _hoisted_6 = {
  href: "/cookies",
  class: "cookie-banner__link"
}
const _hoisted_7 = {
  href: "/privacy",
  class: "cookie-banner__link"
}
const _hoisted_8 = { class: "cookie-banner__actions" }

import { ref, onMounted } from 'vue';
import { useLanguage } from '../composables/useLanguage';

const CONSENT_KEY = 'helfer-cookie-consent';

export default /*@__PURE__*/_defineComponent({
  __name: 'CookieConsentBanner',
  setup(__props) {

const visible = ref(false);
const { t } = useLanguage();

onMounted(() => {
  // Never show in the Electron desktop app
  if (typeof window !== 'undefined' && (window as any).__CAFE_DESKTOP_RUNTIME__) return;

  try {
    const stored = window.localStorage.getItem(CONSENT_KEY);
    if (!stored) {
      visible.value = true;
    }
  } catch {
    // localStorage unavailable — skip banner
  }
});

function saveConsent(analytics: boolean) {
  try {
    window.localStorage.setItem(CONSENT_KEY, JSON.stringify({
      necessary: true,
      analytics,
      ts: Date.now(),
    }));
  } catch {
    // ignore
  }
  visible.value = false;
}

function acceptAll() {
  saveConsent(true);
}

function acceptNecessary() {
  saveConsent(false);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "cookie-slide" }, {
      default: _withCtx(() => [
        (visible.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "cookie-banner",
              role: "dialog",
              "aria-label": _unref(t)('cookie.dialogLabel', 'Cookie consent'),
              "aria-live": "polite"
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)('cookie.heading')), 1),
                  _createElementVNode("p", _hoisted_5, [
                    _createTextVNode(_toDisplayString(_unref(t)('cookie.body')) + " ", 1),
                    _createElementVNode("a", _hoisted_6, _toDisplayString(_unref(t)('cookie.moreInfo')), 1),
                    _cache[0] || (_cache[0] = _createTextVNode(" · ", -1)),
                    _createElementVNode("a", _hoisted_7, _toDisplayString(_unref(t)('cookie.privacy')), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "cookie-banner__btn cookie-banner__btn--primary",
                    onPointerdown: _withModifiers(acceptAll, ["stop","prevent"]),
                    onClick: _withModifiers(acceptAll, ["stop","prevent"])
                  }, _toDisplayString(_unref(t)('cookie.acceptAll')), 33),
                  _createElementVNode("button", {
                    type: "button",
                    class: "cookie-banner__btn cookie-banner__btn--secondary",
                    onPointerdown: _withModifiers(acceptNecessary, ["stop","prevent"]),
                    onClick: _withModifiers(acceptNecessary, ["stop","prevent"])
                  }, _toDisplayString(_unref(t)('cookie.necessaryOnly')), 33)
                ])
              ])
            ], 8, _hoisted_1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})